import { LIMIT_PAGINATE } from '@/constants/default';
import queryString from 'query-string';

interface DataQuery {
    [key: string]: any
}

export const dataQueryApi = (stringQuery: string, {limit = LIMIT_PAGINATE, field = "created_at", order = "desc", ...more}): DataQuery => {
    const parsed = queryString.parse(stringQuery)
    let data: DataQuery = {
        s: parsed.s || "",
        f: parsed.f || field,
        o: (parsed?.o || order) === "desc",
        p: parsed?.p || 1,
        l: parsed?.l || limit
    }
    for (const [key, value] of Object.entries(more)) {
        data[key] = value
    }
    return data 
}

export const dataQueryClient = (stringQuery: string, {limit = LIMIT_PAGINATE, field = "created_at", order = "desc", ...moreDefault}: DataQuery = {}): DataQuery => {
    const {p, s, o, f, l, ...more} = queryString.parse(stringQuery)
    const data: DataQuery = {
        p: p?.toString() || "1",
        s: s?.toString() || "",
        o: o ? o === "asc" ? "asc" : "desc" : order,
        f: f?.toString() || field,
        l: l || limit,
        ...more
    }
    for (const [key, value] of Object.entries(moreDefault)) {
        data[key] = value
    }
    return data
}